import Step from "@mui/material/Step";
import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
	[`&.${stepConnectorClasses.alternativeLabel}`]: {
		top: 11,
	},
	[`&.${stepConnectorClasses.active}`]: {
		[`& .${stepConnectorClasses.line}`]: {
			background: theme.palette.primary.main,
		},
	},
	[`&.${stepConnectorClasses.completed}`]: {
		[`& .${stepConnectorClasses.line}`]: {
			background: theme.palette.company_light.main,
		},
	},
	[`& .${stepConnectorClasses.line}`]: {
		backgroundColor: "#ddd",
		border: 0,
		borderRadius: 1,
		height: 3,
	},
}));

export default function FormStepper({ active_step }) {
	const { t } = useTranslation();

	const steps = [t("sign_up.form.progress_bar.debtor"), t("sign_up.form.progress_bar.address")];

	return (
		<Stepper
			alternativeLabel
			activeStep={active_step}
			connector={<ColorlibConnector />}
			sx={{
				mx: "auto",
				my: { md: 5, xs: 2.5 },
				width: {
					md: "60%",
					xs: "100%",
				},
			}}
		>
			{steps.map((label) => (
				<Step key={label}>
					<StepLabel>
						<Typography fontSize={{ md: 14, xs: 10 }}>{label}</Typography>
					</StepLabel>
				</Step>
			))}
		</Stepper>
	);
}
